const $ = jQuery.noConflict();

const animatedChart = () => {
	// Cache DOM
	const $window = $(window);
	const section = $('.animated-chart');
	const dataArray = Array.from(document.querySelectorAll('.chart-data-item'));
	const dataItems = [];
	let isOn = false;

	dataArray.forEach((element) => {
		dataItems.push({
			label: `${element.dataset.label}`,
			backgroundColor: `${element.dataset.color}`,
			borderColor: `${element.dataset.color}`,
			fill: false,
			showLine: true,
			lineTension: 0,
			pointBackgroundColor: `${element.dataset.color}`,
			pointHoverBorderColor: 'rgb(255, 255, 255)',
			pointRadius: 6,
			pointHoverBorderWidth: 3,
			pointHoverRadius: 9,
			data: JSON.parse(element.textContent),
		});
	});

	// Functions
	function createChart() {
		// Data
		const chartData = {
			datasets: dataItems,
		};
		// Options
		const chartOptions = {
			responsive: true,
			maintainAspectRatio: false,
			scales: {
				xAxes: [{
					type: 'linear',
					position: 'bottom',
					gridLines: {
						display: false,
						drawBorder: false,
					},
					ticks: {
						padding: 30,
						beginAtZero: true,
						// suggestedMax: 600,
						fontColor: '#6d4f96',
						fontSize: 16,
						fontFamily: 'Poppins',
					},
				}],
				yAxes: [{
					gridLines: {
						color: '#6d4f96',
						drawBorder: false,
					},
					ticks: {
						padding: 35,
						beginAtZero: true,
						suggestedMax: 3000,
						fontColor: '#6d4f96',
						fontSize: 16,
						fontFamily: 'Poppins',
					},
				}],
			},
			tooltips: {
				callbacks: {
					title: tooltipItem => `Day ${[tooltipItem[0]['xLabel']]}`,
					label: (tooltipItem) => {
						const value = (tooltipItem['yLabel']).toString().replace('.', ',');
						return `${[value]} pg/ml`;
					},
					afterLabel: () => '',
					footer: () => ' ',
				},
				displayColors: false,
				xPadding: 12,
				yPadding: 12,
				cornerRadius: 2,
				caretPadding: 18,
				footerMarginTop: 0,
				footerFontSize: 7,
				backgroundColor: '#fefefe',
				titleFontStyle: '600',
				titleFontFamily: 'Poppins',
				titleFontColor: '#3f1c6f',
				titleFontSize: 13,
				bodyFontStyle: '600',
				bodyFontFamily: 'Poppins',
				bodyFontColor: '#3f1c6f',
				bodyFontSize: 13,
			},
			legendCallback: (chart) => {
				const legendHtml = [];
				legendHtml.push('<ul>');
				for (let i = 0; i < chart.data.datasets.length; i += 1) {
					legendHtml.push(`
						<li style='color:${chart.data.datasets[i].backgroundColor}' data-index=${chart.legend.legendItems[i].datasetIndex}>
							<i style='background-color:${chart.data.datasets[i].backgroundColor}; border-color:${chart.data.datasets[i].backgroundColor};'>
								<span style='border-color:${chart.data.datasets[i].backgroundColor}'></span>
							</i>
							<span>${chart.data.datasets[i].label}</span>
						</li>
					`);
				}
				legendHtml.push('</ul>');
				return legendHtml.join('');
			},
			legend: {
				display: false,
			},
		};

		function updateDataset(e, datasetIndex) {
			const index = datasetIndex;
			const ci = e.view.chart;
			const meta = ci.getDatasetMeta(index);
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
			ci.update();

			return meta.hidden;
		}

		// Bind events
		$('#chartLegend').off();
		$('#chartLegend').on('click', 'ul > li', function (e) {
			const index = $(this).closest('li').data('index');
			const isHidden = updateDataset(e, index);
			isHidden ? $(this).find('i').addClass('dot-hidden') : $(this).find('i').removeClass('dot-hidden');
		});

		// Create chart
		const ctx = document.getElementById('myChart').getContext('2d');
		window.chart = new Chart(ctx, {
			type: 'scatter',
			data: chartData,
			options: chartOptions,
		});
		document.getElementById('chartLegend').innerHTML = chart.generateLegend();
	}

	function initializeChart() {
		if (section.length) {
			if ($window.width() >= 800) {
				if (!isOn) {
					isOn = true;
					createChart();
				}
			} else {
				if (isOn) {
					isOn = false;
					window.chart.destroy();
				}
			}
		}
	}

	// Bind Events
	window.addEventListener('resize', () => {
		initializeChart();
	});

	initializeChart();
};

export default animatedChart;
